<main>
  <loading-overlay [isLoading]="isLoading > 0" />

  <header>
    <div class="headline">
      <h1>Station {{ currentMachine()?.assetId }} : {{ currentMachine()?.name }}</h1>
    </div>
    <div class="buttons">
      <p-button label="Back" (onClick)="cancelOperation()" />
    </div>
  </header>

  <section class="content">
    <p-panel>
      <p-card>
        <div class="flex flex-col gap-3">
          <label for="" class="font-bold">Search By Finishing Route Number</label>
          <p-autoComplete
            styleClass="w-full"
            inputStyleClass="w-full"
            dropdownIcon="pi pi-search"
            showClear="true"
            [dropdown]="true"
            (onDropdownClick)="searchRouteProductionCard($event)"
          />
        </div>
      </p-card>
    </p-panel>

    @if (finishingRouteSelected()) {
      <p-panel>
        <ng-template pTemplate="icons">
          <p-button [label]="buttonLabel()" [disabled]="!canProceedWithAction() || isLoading > 0 || !isFinishingAdmin" [loading]="isLoading > 0" (onClick)="startProcess()" />
        </ng-template>

        <div class="my-5">
          <app-finishing-card [finishingRouteProductionCard]="finishingRouteSelected()" [showCompleteCard]="true" />
        </div>
      </p-panel>
    } @else {
      <p-panel header="No Finishing Route Selected" />
    }

    <p-panel>
      <p-card data-variant="compact">
        <p-table>
          <ng-template pTemplate="header">
            <tr>
              <th>Production Card</th>
              <th>Client</th>
              <th>Brand</th>
              <th>Client PO</th>
              <th>Work Order</th>
              <th>Routes</th>
              <th>Processes</th>
              <th>Date</th>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </p-panel>
  </section>
</main>
